import { VList } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import Consideration from './Consideration/Consideration'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  'data-cy': `consideration-list`,
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ConsiderationList = ({ considerations }) => (
  <Layout>
    {renderList(
      ({ title, description }) => (
        <Consideration title={title} description={description} />
      ),
      considerations
    )}
  </Layout>
)

ConsiderationList.propTypes = {
  considerations: PropTypes.arrayOf(PropTypes.object).isRequired,
}

ConsiderationList.defaultProps = {}

export default ConsiderationList
